import { Directive, computed, input, signal } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';

let nextFieldId = 0;

/**
 * Shared ControlValueAccessor plumbing + field chrome inputs
 * (label, helper text, error text, required) for ds-* form controls.
 */
@Directive()
export abstract class FieldBase<T> implements ControlValueAccessor {
  label = input.required<string>();
  helperText = input<string | undefined>(undefined);
  errorText = input<string | undefined>(undefined);
  required = input(false);

  protected readonly fieldId = `ds-field-${nextFieldId++}`;
  protected readonly value = signal<T | null>(null);
  protected readonly disabled = signal(false);

  protected onChange: (value: T | null) => void = () => {};
  protected onTouched: () => void = () => {};

  protected readonly describedBy = computed(() => {
    const ids: string[] = [];
    if (this.helperText()) ids.push(`${this.fieldId}-helper`);
    if (this.errorText()) ids.push(`${this.fieldId}-error`);
    return ids.length ? ids.join(' ') : null;
  });

  writeValue(value: T | null): void {
    this.value.set(value);
  }

  registerOnChange(fn: (value: T | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled.set(isDisabled);
  }
}
